<div class="row" id="jsrs-stickyContainer">
  <div class="">
    <a class="close-reveal-modal"><i class="icon-Close"></i></a>
    <div class="small-12 columns">
      <div class="jsrs-resizerContainer">
        <h3>{{ 'create.mailbox.define.user.name.title' | translate }}</h3>
        <mprd-alerts-container></mprd-alerts-container>
        <form [formGroup]="createMailboxForm" (ngSubmit)="createMailbox()">
          <mprd-mailbox-id
            (mailIdFormStatusAndValue)="onMailIdFormStatusAndValue($event)"
          ></mprd-mailbox-id>
          <px-password
            [componentWidthStyleClass]="'small-12 medium-6 columns end'"
            (onPasswordFormStatusAndValue)="onPasswordFormStatusAndValue($event)"
            [customLengthValidation]="customLengthValidation"
            [showNotIdenticalErrorOnChange]="true"
          ></px-password>
          <p class="right rs-margin-right2">
            <span *ngIf="showLoadingSpinner">
              <px-loading-spinner></px-loading-spinner>
            </span>
          </p>
          <div class="rs-padding-bottom2">
            <button
              [pxAnalyticsElementClicked]="{
                event_detail: 'validate',
                event_location: 'myWebMail.create',
                event_action: 'click'
              }"
              type="submit"
              class="rs-btn rs-no-margin-bottom"
              [disabled]="!createMailboxForm.valid || showLoadingSpinner"
              [ngStyle]="{
                'pointer-events': !createMailboxForm.valid ? 'none' : 'auto',
                cursor: showLoadingSpinner ? 'not-allowed' : 'auto'
              }"
            >
              {{ 'create.mailbox.create.button.title' | translate }}
            </button>
            <a
              href="javascript:void(0)"
              class="rs-padding-left2"
              (click)="onCancel()"
              [pxAnalyticsElementClicked]="{
                event_detail: 'cancel',
                event_location: 'myWebMail.create',
                event_action: 'click'
              }"
            >
              {{ 'create.mailbox.cancel.link.title' | translate }}</a
            >
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
